import { useEffect } from "react";
import { api } from "@/lib/api";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ImpactStats from "@/components/ImpactStats";
import ProgramSection from "@/components/ProgramSection";
import DonationSection from "@/components/DonationSection";
import MissionVision from "@/components/MissionVision";
import GetInvolved from "@/components/GetInvolved";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ProgramTicker from "@/components/ProgramTicker";
import ImpactOutcomes from "@/components/ImpactOutcomes";
import AboutSection from "@/components/AboutSection";

export default function Home() {
  useEffect(() => {
    api.get("/").catch(() => {});
  }, []);

  const scrollToDonate = () => {
    const el = document.getElementById("donate");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToProgram = () => {
    const el = document.getElementById("program");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-brand-cream">
      <Navigation onDonate={scrollToDonate} />
      <Hero onDonate={scrollToDonate} onLearnMore={scrollToProgram} />
      <ProgramTicker />
      <MissionVision />
      <ProgramSection />
      <ImpactStats />
      <DonationSection />
      <ImpactOutcomes />
      <GetInvolved onDonate={scrollToDonate} />
      <AboutSection />
      <ContactSection />
      <Footer onDonate={scrollToDonate} />
    </div>
  );
}
